import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useQueryParams = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const handleRemoveQueryParam = useCallback(
		(param: string) => {
			const nextParams = new URLSearchParams(globalThis.location.search);
			nextParams.delete(param);
			setSearchParams(nextParams, { replace: true });
		},
		[setSearchParams]
	);

	const params = useMemo(
		() => Object.fromEntries(searchParams.entries()),
		[searchParams]
	);

	return {
		params,
		handleRemoveQueryParam
	};
};

export default useQueryParams;
